/**
 * The AI Video creatives the "Made for you" flow is following. Their finish is announced by its own
 * dock and "Your video is ready" popup, so the app's generation toast skips them: shown as well, it
 * covered the dock in the same corner. Its own file so the app shell can read it without pulling in
 * the flow itself.
 */
export const MADE_FOR_YOU_VIDEO_IDS = new Set<number>();
